import { ConfigProvider, App } from 'antd'
import { ReactNode, useRef } from 'react'
import { CustomizeRequiredMark } from '@/components/commons/customizeRequiredMark'
import idID from 'antd/locale/id_ID'
import enUS from 'antd/locale/en_US'
import i18n from './i18n'

export const primaryColor = '#037dc8'
export const secondaryColorTheme = '#E85187'
// const primaryColor = '#202020'
interface ITheme {
  children?: ReactNode
}
export const Theme = ({ children }: ITheme) => {
  const modalContainerRef = useRef<HTMLDivElement>(null)
  return (
    <ConfigProvider
      locale={i18n.language === 'id' ? idID : enUS}
      form={{
        requiredMark: CustomizeRequiredMark,
        scrollToFirstError: true,
        validateMessages: {
          required() {
            if (i18n.language === 'id') {
              return '${label} wajib diisi'
            }
            return 'Please enter ${label}'
          },
        },
        tooltip: {},
      }}
      getPopupContainer={() => modalContainerRef.current as HTMLElement}
      componentSize="large"
      theme={{
        components: {
          Progress: {
            defaultColor: primaryColor,
          },
          Form: {
            itemMarginBottom: 16,
          },
          Spin: {
            dotSize: 16, // default biasanya lebih besar
            dotSizeSM: 12,
            dotSizeLG: 20,
          },
          Table: {
            headerBg: `#d8e6f0`,
          },
        },
        token: {
          colorPrimary: primaryColor,
        },
      }}
    >
      <App>{children}</App>
    </ConfigProvider>
  )
}
